import React, { useEffect, useRef, useState } from "react"
import { warnAgent } from "utils/dom"
import { getRequest, putRequest } from "utils/request"
import {
  Popover,
  CircularProgress,
  IconButton,
  Badge,
  makeStyles,
} from "@material-ui/core"
// import NotificationsIcon from "@material-ui/icons/Notifications"
import { useNotification } from "hooks/notification"
import { translate } from "translate/i18n"
import { Ticket } from "definitions/Ticket"
import { useHistory } from "react-router-dom"
import format from "utils/dateFormat"
import { Notification } from "definitions/Others"
import { toast } from "react-toastify"
import { useAuth } from "hooks/auth"

const useMuiStyles = makeStyles({
  iconButton: {
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: "transparent !important", // Keep background transparent on hover
    },
  },
})

export function NotificationsButton(): JSX.Element {
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [loadingNotifications, setLoadingNotifications] = useState(false)
  const [countnotifications, setCountNotifications] = useState(0)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const muiClasses = useMuiStyles()

  const {
    handleUpdateTicketList,
    addSelectedCompany,
    listCompanies,
    updateHeaderSelectedTicket,
    updateNotificationCount,
  } = useNotification()

  //@ts-ignore
  const { signOut, socket } = useAuth()
  const history = useHistory()

  const searchNotifications = async (config: { silent: boolean }) => {
    setLoadingNotifications(true)
    const ReturnGet = await getRequest<Notification[]>(`/notifications`)
    if (ReturnGet.success) {
      setNotifications(ReturnGet.data)
      setCountNotifications(ReturnGet.data.length)
      warnAgent(ReturnGet.data.length, config)
    }
    setLoadingNotifications(false)
  }

  const readAll = async () => {
    putRequest("/notifications/read/all").then((response) => {
      if (response.success) {
        searchNotifications({ silent: true })
        handleUpdateTicketList()
        handlePopoverClose()
      }
    })
  }

  const handleNotificationClick = async (value: {
    ticket: Ticket
    Ticket: Ticket
    TicketId: number
  }) => {
    let CompanyId = value.Ticket.skute ? 2 : value.Ticket.Company.id

    listCompanies.forEach((data) => {
      if (data.id === CompanyId) {
        addSelectedCompany({
          value: data.id,
          id: data.id,
          label: data.nickName,
          logo: data.pathLogo,
          trial: data.trial,
          trialLimit: data.trialValidate,
          dueDay: data.dueDay,
          usersLimit: data.usersLimit,
          ticketToShow: data.ticketToShow,
        })
      }
    })

    await putRequest(`/notifications/${value.TicketId}`).then((resp) => {
      if (resp.success) {
        history.push(`../../../../../dashboard/chat/`)
        updateHeaderSelectedTicket(value.TicketId, value.ticket)
        handlePopoverClose()
      }
    })
  }

  const listenToSocket = (data: string) => {
    if (data) {
      if (data === "logoff") {
        toast.info(
          "Usuário Desconectado. Esse usuário fez login em outro navegador!"
        )
        signOut()
      } else {
        getRequest(`/notifications/count`).then((res) => {
          //@ts-ignore
          const value = typeof res.data === "number" ? res.data : res.data.data
          setCountNotifications(value)
          warnAgent(value)
        })
      }
    }
  }

  useEffect(() => {
    if (socket) {
      socket.on("notification", listenToSocket)
    }
  }, [socket])

  useEffect(() => {
    searchNotifications({ silent: true })
  }, [])

  useEffect(() => {
    const updateCount = () => {
      getRequest(`/notifications/count`).then((res) => {
        console.log("notifications/count res", res)
        if (!res) {
          return
        }
        //@ts-ignore
        const value = typeof res.data === "number" ? res.data : res.data.data
        setCountNotifications(value)
        warnAgent(value)
      })
    }
    updateCount()
  }, [updateNotificationCount])

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    searchNotifications({ silent: true })
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const isPopoverOpen = Boolean(anchorEl)

  return (
    <div
      style={{
        display: "flex",
        height: "var(--header-height)",
        alignItems: "center",
        padding: "0 15px",
      }}
    >
      <IconButton
        onClick={handlePopoverOpen}
        classes={{ root: muiClasses.iconButton }}
      >
        <Badge badgeContent={countnotifications}>
          <i
            className="dripicons-bell"
            style={{
              fontSize: 20,
            }}
          ></i>
        </Badge>
      </IconButton>
      <Popover
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div
          style={{ overflowY: "auto", maxHeight: 400, width: 350, padding: 10 }}
        >
          {!loadingNotifications ? (
            <div>
              <p
                onClick={readAll}
                style={{
                  position: "absolute",
                  fontSize: 12,
                  right: 6,
                  top: 6,
                  cursor: "pointer",
                }}
              >
                {translate("readAll")}
              </p>
              <div style={{ marginBottom: 20 }}>
                {translate("notifications")}
              </div>
              {notifications.map((data, index) => (
                <div
                  key={index}
                  onClick={() => handleNotificationClick(data)}
                  className="area-line-text-notification"
                  style={{ cursor: "pointer", padding: "10px 0" }}
                >
                  <div className="timeline-icon">
                    <img
                      alt="notificações"
                      src={data.Ticket.Company.pathLogo}
                      className="img-notification-list"
                      style={{ marginRight: 5, width: 40, height: 40 }}
                    />
                  </div>
                  <div style={{ marginBottom: 5 }}>
                    <p style={{ marginBottom: 0 }}>{data.title}</p>
                    <span className="timeline-date">
                      {format(data.updatedAt, "dd/MM/yyyy HH:mm:ss")}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <CircularProgress size={25} />
          )}
        </div>
      </Popover>
    </div>
  )
}
